import request from '@/utils/request';

export function getResourceList(): Promise<any> {
  return request('/sys/resource/allList', {
    method: 'POST',
  });
}

export interface ResourceAddProps {
  name: string;
  remarks: string;
  resourceIds: string[]
}


export function resourceAdd(data: ResourceAddProps): Promise<any> {
  return request('/sys/resource/add', {
    method: 'POST',
    data
  });
}



/**
 * 单个菜单信息获取
 * 
 */
export function resourceGet(id: string): Promise<any> {
  return request('/sys/resource/get', {
    method: 'POST',
    data: {
      resourceId: id
    }
  });
}

/**
 * 菜单删除
 * 
 */
export function resourceDel(id: string): Promise<any> {
  return request('/sys/resource/delete', {
    method: 'POST',
    data: {
      id
    }
  });
}


/**
 * 菜单更新
 * 
 */
export function resourceUpdate(data: any): Promise<any> {
  return request('/sys/resource/update', {
    method: 'POST',
    data
  });
}








